module.exports = __webpack_public_path__ + "static/media/31JFA8.e27d441d.jpg";